import { CircularProgress } from '@mui/material';
import { useAppSelector } from 'store/store';

export const Spinner = () => {
  const isLoading: boolean = useAppSelector((state) => {
    return state.loadingData.loading;
  });

  return (
    isLoading && (
      <div className="fixed flex justify-center items-center z-40 backdrop-opacity-10 backdrop-invert top-0 left-0 w-screen h-screen">
        <CircularProgress />
      </div>
    )
  );
};

export default Spinner;
